module.exports = __webpack_public_path__ + "static/media/004.ed4e2789.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/totoro/004.gif
// module id = 837
// module chunks = 0